"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyBusinessStarMap = void 0;
exports.MyBusinessStarMap = {
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    FIVE: 5,
    NONE: 0,
};
